//libary
import React, { Component } from 'react';
import { isMobile } from 'react-device-detect';
//image
import logo from '../../images/logo.png';
class Header extends Component {


    render() {
        return <header className="headBlock">
            <a rel="noopener noreferrer" target="_blank" href="https://www.anuefund.com/">
                <img className="logo" src={logo} alt="anueFundLogo" />
            </a>
        </header>
    }
}
export default Header;